<template>
  <div class="c-card infos">
    <div>
      <div class="c-card--title">
        <h3>{{$t('profile.info.title')}}</h3>
      </div>
      <div class="c-card--content">
        <div class="select-gender">
          <select name="title" id="title" class="form-control gender" v-model="title">
            <option value="M">{{$t('profile.info.gender.M')}}</option>
            <option value="F">{{$t('profile.info.gender.F')}}</option>
          </select>
        </div>
        <text-input v-model="firstName" :placeholder="$t('profile.info.firstName')" name="firstName" icon="person"
                    class="fields"/>
        <text-input v-model="lastName" :placeholder="$t('profile.info.lastName')" name="lastName" icon="person"
                    class="fields"/>
        <vue-phone-number-input :value="defaultPhone" :default-country-code="defaultCountry" class="fields"
                                :translations="phoneLocale" @update="phoneUpdate" ref="phoneInput"/>
        <password-input name="password" :placeholder="$t('profile.info.password')" icon="code" v-model="password"
                        class="fields"/>
      </div>
      <div class="c-card--footer">
        <button class="colored-btn red-btn" @click="openModal"><i class="las la-check"></i> {{$t('profile.info.btn')}}
        </button>
      </div>
    </div>
    <div v-on:click.self="closeModal" class="modal--wrapper" :class="{'modal-open': modalOpenState}">
      <div class="modal">
        <div class="modal--title">
          <div class="modal--title-text">{{$t('profile.info.modal.title')}}</div>
          <div class="modal--title-actions">
            <modal-close-btn  @click="closeModal"/>
          </div>
        </div>
        <div class="modal--content" v-if="modalLoading">
          <div class="loader">
            <loader/>
          </div>
        </div>
        <div class="modal--content" v-else>
          <p>{{$t('profile.info.modal.head')}}</p>
          <div class="error" v-if="modalError">
            <p>{{$t('profile.info.modal.errors.' + modalError) || modalError}}</p>
          </div>
          <form action="" class="verification-form" @keydown.enter.prevent="handleEnterKey">
            <div class="fields password">
              <password-input
                name="password"
                :placeholder="$t('profile.info.modal.password')"
                :error="!!modalError"
                v-model="securePwd"
                aria-autocomplete="none"
                icon="code"
              />
            </div>
          </form>
        </div>
        <div class="modal--footer" v-if="!modalLoading">
          <button class="card-button" @click="sendUpdate">{{$t('profile.info.modal.btn')}}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TextInput from '../../../components/text-input';
import {parsePhoneNumberFromString} from 'libphonenumber-js';
import Loader from '../../../components/loader.component';
import PasswordInput from '../../../components/password-input';
import {mapState} from 'vuex';
import ModalCloseBtn from "../../../components/modal-close-btn";
import store from "../../../stores";

export default {
  name: 'personnal-infos',
  components: {ModalCloseBtn, TextInput, PasswordInput, Loader},
  computed: mapState({
    loading: s => s.client.loading,
    modalLoading: s => s.client.modalLoading,
  }),
  data() {
    return {
      unwatch: null,
      modalOpenState: false,
      phoneLocale: {
        countrySelectorLabel: this.$t('profile.info.phone.countrySelectorLabel'),
        countrySelectorError: this.$t('profile.info.phone.countrySelectorError'),
        phoneNumberLabel: this.$t('profile.info.phone.phoneNumberLabel'),
        example: this.$t('profile.info.phone.example'),
      },
      modalError: null,
      title: 'M',
      firstName: '',
      lastName: '',
      phone: '',
      defaultPhone: '',
      defaultCountry: '',
      password: '',
      securePwd: '',
    };
  },
  mounted() {
    this.$data.unwatch = this.$store.watch((state, getters) => {
      this.firstName = state.client.client.firstName;
      this.lastName = state.client.client.lastName;
      this.title = state.client.client.title;
      if (typeof this.unwatch === 'function') this.unwatch();
      this.unwatch = null;
    });
    const inputPhone = this.$store.state.client.client.phone;
    const phoneParser = parsePhoneNumberFromString(this.$store.state.client.client.phone);
    this.defaultPhone = inputPhone.replace(`+${phoneParser.countryCallingCode}`, '0');
    this.defaultCountry = phoneParser.metadata.country_calling_codes[phoneParser.countryCallingCode][0];
    this.$refs.phoneInput.emitValues({countryCode: this.defaultCountry, phoneNumber: this.defaultPhone});
  },
  beforeDestroy() {
    if (typeof this.unwatch === 'function') {
      this.unwatch();
    }
  },
  methods: {
    async sendUpdate() {
      const data = {
        title: this.title,
        firstName: this.firstName.trim(),
        lastName: this.lastName.trim(),
        phone: this.phone,
        password: this.password,
        securePwd: this.securePwd,
      };
      this.modalError = await this.$store.dispatch('client/updateProfile', data);
      if (!this.modalError) {
        this.closeModal();
      }
    },
    handleEnterKey(event) {
      if (event.key === 'Enter') {
        event.preventDefault();
        // Call the sendUpdate method
        this.sendUpdate();
      }
    },
    closeModal() {
      if (this.modalLoading) {
        return;
      }
      this.securePwd = '';
      this.modalError = null;
      this.modalOpenState = false;
    },
    openModal() {
      this.modalOpenState = true;
    },
    phoneUpdate(v) {
      this.defaultPhone = v.formatNational || v.phoneNumber;
      if (v.isValid) {
        this.phone = v.e164;
      } else {
        this.phone = '';
      }
    },
  },
};
</script>

<style scoped>
.loader {
  height: 100px;
}

.card-button {
  height: 40px;
}

.modal {
  padding: 10px;
}

.modal--title {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.modal--title-text {
  font-size: 2em;
}

.verification-form {
  margin-bottom: 1em;
}

</style>



// WEBPACK FOOTER //
// src/pages/client/part/personnal-infos.vue